module.exports = __webpack_public_path__ + "static/media/help.ed8be76d.svg";